import Inputmask from "inputmask";
import sendMail from "./sendMail.js";

function sendFormCheckout() {
  const validateName = (name) => {
    return name.length >= 2 && name.length < 50 && /^[а-яА-Я]/.test(name);
  };

  const validatePhone = (phone) => {
    return /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/.test(phone);
  };

  const validatedField = (selector, validator) => {
    $(selector).each(function () {
      const value = $(this).val();
      if (validator(value)) {
        $(this).removeClass('error').addClass('filled');
      } else {
        $(this).addClass('error').removeClass('filled');
        $('.checkout__submit').addClass('checkout__submit-disabled');
      }
      if (value.length === 0) {
        $(this).removeClass('error').removeClass('filled');
        $('.checkout__submit').addClass('checkout__submit-disabled');
      }
    });
  };

  const validateInputs = () => {
    validatedField('.checkout__form input[name="name"]', validateName);
    validatedField('.checkout__form input[name="phone"]', validatePhone);
    validatedField('.checkout__form input[name="address"]', validateName);
  };

  $('.checkout__form input[name="name"], .checkout__form input[name="phone"], .checkout__form input[name="address"], .checkout__form input[name="email"]').on('input', validateInputs);

  $('.checkout__block-methods input, .checkout__block-types input').on('input', function () {
    $('.checkout__block-methods input:checked, .checkout__block-types input:checked').each(function () {
      $(this).addClass('filled');
    });
  });

  $('.checkout__form input').on('input', function () {
    const allValid = 
      $('.checkout__form input[name="name"]').length === $('.checkout__form input[name="name"].filled').length &&
      $('.checkout__form input[name="phone"]').length === $('.checkout__form input[name="phone"].filled').length &&
      $('.checkout__form input[name="address"]').length === $('.checkout__form input[name="address"].filled').length;

    const noErrors =
      $('.checkout__form input[name="name"]').length === $('.checkout__form input[name="name"]:not(.error)').length &&
      $('.checkout__form input[name="phone"]').length === $('.checkout__form input[name="phone"]:not(.error)').length &&
      $('.checkout__form input[name="address"]').length === $('.checkout__form input[name="address"]:not(.error)').length;

    if (allValid && noErrors) {
      $('.checkout__block-types, .checkout__block-methods').removeClass('hidden');
      $('.checkout__submit').removeClass('checkout__submit-disabled');
    } else {
      $('.checkout__block-types, .checkout__block-methods').addClass('hidden');
      $('.checkout__submit').addClass('checkout__submit-disabled');
    }
  });

  function sendPopupForm() {
    $('.checkout__form').each(function () {
      $(this).on('submit', function (e) {
        e.preventDefault();
        if (
          !$('.checkout__form input[name="name"]').hasClass('error') &&
          !$('.checkout__form input[name="surname"]').hasClass('error') &&
          !$('.checkout__form input[name="phone"]').hasClass('error')
        ) {
          sendMail($(this)).then(() => {
            $(this).get(0).reset();
            $('input').removeClass('error filled');
            $('.checkout__submit').addClass('checkout__submit-disabled');
          });
        }
      });
    });
  }
  sendPopupForm();

  function inputMask() {
    $('input[type="tel"]').each(function () {
      const mask = new Inputmask('+7 (999) 999-99-99');
      mask.mask(this);
    });
  }
  inputMask();
}

sendFormCheckout();
